import { render, staticRenderFns } from "./ScrollBoard.vue?vue&type=template&id=12a996ac"
import script from "./ScrollBoard.vue?vue&type=script&lang=js"
export * from "./ScrollBoard.vue?vue&type=script&lang=js"
import style0 from "./ScrollBoard.vue?vue&type=style&index=0&id=12a996ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports